import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import type { UserAccount } from '@app/models/account.model';
import { QualificationTabComponent } from '@app/pages/admin/entities/users/user-details/qualification-tab/qualification-tab.component';
import { ModalComponent } from '@app/ui-components/modal/modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-qualification-summary-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ModalComponent,
    QualificationTabComponent,
  ],
  templateUrl: './qualification-summary-dialog.component.html',
  styleUrl: './qualification-summary-dialog.component.scss',
})
export class QualificationSummaryDialogComponent {
  @Input() user: UserAccount | null = null;

  constructor(public activeModal: NgbActiveModal) {}

  protected handlePrimaryAction(): void {
    this.activeModal.dismiss();
  }

  protected handleSecondaryAction(): void {
    this.activeModal.close('requalify');
  }
}
